var _loading = '<div id="ajax-loading">' +
	'<div class="spiner-loading">' +
	'<div class="sk-spinner sk-spinner-circle">' +
	'<div class="sk-circle1 sk-circle"></div>' +
	'<div class="sk-circle2 sk-circle"></div>' +
	'<div class="sk-circle3 sk-circle"></div>' +
	'<div class="sk-circle4 sk-circle"></div>' +
	'<div class="sk-circle5 sk-circle"></div>' +
	'<div class="sk-circle6 sk-circle"></div>' +
	'<div class="sk-circle7 sk-circle"></div>' +
	'<div class="sk-circle8 sk-circle"></div>' +
	'<div class="sk-circle9 sk-circle"></div>' +
	'<div class="sk-circle10 sk-circle"></div>' +
	'<div class="sk-circle11 sk-circle"></div>' +
	'<div class="sk-circle12 sk-circle"></div>' +
	'</div>' +
	'</div>' +
	'</div>';

/**/
var monitor_value = false;
var monitor_index = 0;
var _flag_log = true;
var open_alerts = [];
if (typeof _log != 'function') {
	window._log = function (str) {
		if (_flag_log) {
			////console.log(str);
			if (monitor_value) {
				////console.log("NUM: " + monitor_index++);
				////console.log("MONITOR::::::" + jQuery(monitor_value).val());
				// ////console.trace();
			}
		}
	};
}
/*js-ajax-load-content*/
/**********************************************************************************/
var js_ajax_load_content = {
	init: function () {
		_this = this;
		jQuery('.js-ajax-load-content').each(function (index, el) {
			_auto = jQuery(this).attr('data-auto');
			if (_auto == 'false') { } else {
				_this.part(this, index, el);
			}
		});
	},
	partWithParams: function (_this, _params2, _params3) {
		/*******************************************/
		_params = jQuery(_this).attr('data-params');
		_params = JSON.parse(_params);
		$.extend(_params, _params, _params2);
		_params = JSON.stringify(_params);
		jQuery(_this).attr('data-params', _params);
		/*******************************************/
		_params = jQuery(_this).attr('data-trigger-params');
		_params = JSON.parse(_params);
		$.extend(_params, _params, _params3);
		_params = JSON.stringify(_params);
		jQuery(_this).attr('data-trigger-params', _params);
		this.part(_this, 1, 1);
	},
	part: function (_this_param, index, el) {
		/* esta funcion toma los parametros del contenedor "data-*"  y ejecuta un llamada ajax. 
		 */
		_this_param = jQuery(_this_param);
		_flag_loading = _this_param.attr('data-loading');
		_this_param_id = _this_param.attr('ID');
		if (_flag_loading == "false") {
			// no se pone el loading 
		} else {
			if (_this_param.find('.loading').length > 0) {
				if (_this_param.find('.loading #ajax-loading').length > 0) { } else {
					_this_param.find('.loading').append(_loading);
				}
			} else {
				if (_this_param.find("#ajax-loading").length > 0) { } else {
					_this_param.append(_loading);
				}
			}
		}

		/*
		_log("****************************************************");
		_log("Verificando loading");
		_log('AJAX-LOADING:' + _this_param.find("#ajax-loading").length);
		_log("****************************************************");
		*/
		_action = _this_param.attr('data-action');
		_empty = _this_param.attr('data-empty');
		_auto = _this_param.attr('data-auto');
		_id = _this_param.attr('id');
		_data = _this_param.attr('data-params');
		_data = JSON.parse(_data);
		_data.eq = index;
		_data.element_id = _id;
		_div_plugin = '.js-ajax-load-content';
		$.ajax({
			url: _action,
			type: 'POST',
			dataType: 'json',
			data: _data,
			context: _this_param
		}).done(function (data) {
			if (data.error == 1) { } else { }
			////console.log("ajax-content");
			////console.log(this);
			//  jQuery(this[0]).find('#ajax-loading').remove();
			//if (data.hasOwnProperty('element_id')) {
			//jQuery('#' + data.element_id + '' + _div_plugin).empty().append(data.content);
			if (_empty == "false") {
				jQuery(this[0]).html(data.content);
			} else {
				jQuery(this[0]).empty().append(data.content);
			}
			////console.log("Finalizando load....");
			//} else {
			//  alert('Error: not return ELEMENT_ID ');
			//}
			////console.log("success");
		}).fail(function () {
			////console.log("error");
		}).always(function (data) {
			//  jQuery(this[0]).find('#ajax-loading').remove();
			/*******************************************************/
			_form_callback = jQuery(this[0]).attr('data-callback');
			if (!_helper_is_null(_form_callback)) {
				temp = _form_callback.split('.');
				if (temp.length == 2) {
					window[temp[0]][temp[1]](data);
				} else {
					window[_form_callback](data);
				}
			}
			/*******************************************************/
			_form_trigger = jQuery(this[0]).attr('data-trigger');
			if (!_helper_is_null(_form_trigger)) {
				_data2 = jQuery(this[0]).attr('data-trigger-params');
				_data = JSON.parse(_data2);
				jQuery('body').trigger(_form_trigger, _data)
				////console.log("CALL js-ajax-load-content/" + _form_trigger);
				////console.log("CALL WITH DATA:");
				////console.log(_data);
			}
			////console.log("complete");
		});

	}
};
jQuery(function () {
	js_ajax_load_content.init();
});

/**********************************************************************************/
/**********************************************************************************/
//----------------------
function _helper_is_null(v) {
	if (v === undefined || v === null) {
		return true;
	} else {
		return false
	}
}

function _init_form() {

	$.each($('form.js-validation-mini'), function (index, el) {
		console.log(" append.. data validate loaded ");
		jQuery(this).attr("data-validate-loaded", 1);
		$(this).validate();

	});

	$.each($('form.js-validation'), function (index, el) {
		console.log(" append.. data validate loaded ");
		jQuery(this).attr("data-validate-loaded", 1);
		$(this).validate();

	});
	$.each($('form.js-validation-simple'), function (index, el) {
		console.log(" append.. data validate loaded ");
		jQuery(this).attr("data-validate-loaded", 1);
		$(this).validate({

			submitHandler: function (form) {
				$.ajax({
					url: form.action,
					type: form.method,
					data: $(form).serialize(),
					dataType: "json",
					success: function (response) {
						alert(response.message);
					}
				});
			}
		});

	});
/*
	$.each($('form.js-validation-plus'), function (index, el) {
		console.log(" append.. data validate loaded ");
		jQuery(this).attr("data-validate-loaded", 1);
		$(this).validate({

			submitHandler: function (form) {
				//	var form = jQuery('form#builder-form')[0]; // You need to use standard javascript object here
				var formData = new FormData(form);

				_trigger = jQuery(form).attr("data-trigger");
				_divparams = jQuery(form).attr("data-divparams");

				$.ajax({
					url: form.action,
					type: form.method,
					data: formData,
					contentType: false,
					processData: false,
					dataType: "json",
					beforeSend: function () {
						// Handle the beforeSend event
						//_loading_show();
						 console.log("loading show");
					},
					complete: function () {
						// Handle the complete event
						//_loading_hide();
						console.log("loading hide");
					},
					success: function (response) {
						//_loading_hide();
						console.log("loading hide");

						if (response.error == '1') {
							//alert(response.message);
							helpers.alert(response.message, 1);
						} else {

							if (response.hasOwnProperty("message") && response.message != '') {
								//alert(response.message);
								helpers.alert(response.message, 0);

							}

							if (response.hasOwnProperty("redirect") && response.redirect != '') {
								location.href = response.redirect;
							}

							if (_trigger) {
								_helper_trigger(_trigger, [form, _divparams, response]);
								//jQuery("body").trigger(_trigger, [form, _divparams])
							}

						}

					}

				});

			}
		});

	});
*/

init_validation_plus();
}

function init_validation_plus() {

	$.each($('form.js-validation-plus'), function (index, el) {
		console.log(" append.. data validate loaded ");
		jQuery(this).attr("data-validate-loaded", 1);
		$(this).validate({
			highlight: function (element) {
				$(element).parent().addClass("field-error");
				$(element).addClass("is-invalid");
			},
			unhighlight: function (element) {
				$(element).parent().removeClass("field-error");
				$(element).removeClass("is-invalid");

			},

			submitHandler: function (form) {
				
				//	var form = jQuery('form#builder-form')[0]; // You need to use standard javascript object here
				var formData = new FormData(form);
				_reset = jQuery(form).attr("data-reset");
				_trigger = jQuery(form).attr("data-trigger");
				_divparams = jQuery(form).attr("data-divparams");

				_type = 'html';
				if (jQuery(form).is("[data-type]")) {
					_type = jQuery(form).attr("data-type");
				}

				_input = jQuery("#sec").find('input');
              
				formData.append(_input.attr("name"), _input.val())
				 
				$.ajax({
					url: form.action,
					type: form.method,
					data: formData,
					contentType: false,
					processData: false,
					dataType: _type,
					headers: {'X-Requested-With': 'XMLHttpRequest'},
					beforeSend: function () {
						// Handle the beforeSend event
						_loading_show();
					},
					complete: function () {
						// Handle the complete event
						_loading_hide();
					},
					success: function (response) {
						_loading_hide();

						response = $.parseJSON(response);

						if (response.hasOwnProperty("error") && response.error == '1') {
							
							
							helpers.alert(response.message, 1);
						} else {

							if (response.hasOwnProperty("message") && response.message != '') {
								//alert(response.message);
								
								helpers.alert(response.message, 0);

							}

							if (response.hasOwnProperty("redirect") && response.redirect != '') {
								location.href = response.redirect;
							}

							if (_trigger) {

								_helper_trigger(_trigger, [form, _divparams, response]);
								//jQuery("body").trigger(_trigger, [form, _divparams])
							}
							if (_reset) {
								jQuery(form)[0].reset();
								jQuery(form).find("input").val('');
								jQuery(form).find("select").val("").trigger("change");
							}

						}

					}

				});

			}
		});

	});

}

function _loading_show() {
	/*	jQuery("#loading").css("opacity", 0.7).fadeIn("600", function() {

		});*/
	//objGenPlugin.fcPreloadFull('body');
	
	
/*	$('body').loading("start");

	setTimeout(function () {
		$('body').loading("stop");
	}, 10000);*/
}

function _loading_hide() {
//	$('body').loading("stop");
	/*
	jQuery("#loading").css("opacity", 0.7).fadeOut('600', function() {
		jQuery("#loading").css("opacity", 1)
	});*/
	//objGenPlugin.fcPreloadFullHide();
}
function _js_init_validation_custom() {
	jQuery('.js-validation-custom').each(function (index, el) {
		_this = jQuery(this);
		_this.validate({
			submitHandler: function (form) {
				// _data = $(form).serialize();
				_id = $(form).attr('id');
				_alert = $(form).attr('data-alert')?$(form).attr('data-alert'):false;
				_alert_title = $(form).attr('data-alert-title');
				_form_callback = $(form).attr('data-callback');
				_reset = $(form).attr('data-reset');
				_alert_message = $(form).attr('data-alert-message');
				_alert_type = $(form).attr('data-alert-type');
				_alert_id = $(form).attr('data-alert-id');
				_data = ($(form).serialize());
				_data += '&' + 'form_index' + '=' + index;
				_data += '&' + 'form_id' + '=' + _id;
				////console.log(_data);
				$.ajax({
					type: "POST",
					url: jQuery(form).attr('action'),
					data: _data,
					context: this,
					dataType: 'json',
					success: function (data) {
						if (data.isOK == 'OK') {
							objGenPlugin.fcPreloadFullHide();
							if (_alert) {
								/*swal({
									title: _alert_title,
									text: _alert_message,
									type: "success"
								});

								 alert();
										*/
								// alert(_alert_type);
								//  alert(_alert_id);
								if (!_helper_is_null(_alert_type) && _alert_type == 'inline') {
									if (!_helper_is_null(_alert_message) && _alert_message != '') {
										jQuery(_alert_id).find('.content').html(_alert_message);
									}
									jQuery(_alert_id).fadeIn(1500);
									setTimeout(function () {
										jQuery(_alert_id).fadeOut(1000, function () { });
									}, 3000);
								} else {
									helpers.alert(_alert_message,0);
								}
							}
						} else {
							if (_alert) {
								/*
								swal({
									title: _alert_title,
									text: _alert_message,
									type: "success"
								});
								*/
								helpers.alert(_alert_message,1);
							}
						}
						//////console.log("1.contexto::");
						//////console.log(this);
						data.custom_context = this;
						jQuery('body').trigger('js_event_form_sucess', [data])
						if (!_helper_is_null(_reset) && _reset == 'true') {
							jQuery(this.currentForm).find("input[type=text], textarea").val("");
						}
						if (!_helper_is_null(_form_callback)) {
							/* func_temp = function(fun, data) {
								 fun(data);
							 }
							 alert(_callback);
							 func_temp(_callback, data);*/
							//_form_callback.call(data);
							temp = _form_callback.split('.');
							if (temp.length == 2) {
								window[temp[0]][temp[1]](data);
							} else {
								window[_form_callback](data);
							}
						}
					}
				});
				return false; // required to block normal submit since you used ajax
			}
		});
	});
}
var placeholder;
jQuery(function () {

	_js_init_validation_custom();
	//*
	/**
	 * [description]
	 * @param  {[type]} event) {                   target [description]
	 * @return {[type]}        [description]
	 */
	jQuery('body').on('click', '.js-modal-click-fake', function (event) {
		target = jQuery(this).attr('data-target');
		jQuery(this).closest('div.modal').find(target).trigger('click');
		/* Act on the event */
	});
	placeholder = {
		add: function () {
			jQuery('.js-placeholder-xs').each(function (index, el) {
				jQuery(this).attr('placeholder', jQuery(this).attr('data-placeholder'));
			});
		},
		remove: function () {
			jQuery('.js-placeholder-xs').each(function (index, el) {
				jQuery(this).attr('placeholder', '');
			});
		},
		main: function () {
			var viewportWidth = $(window).width();
			////console.log("----" + viewportWidth);
			if (viewportWidth < 770) {
				placeholder.add();
			} else {
				placeholder.remove();
			}
		}
	};
	jQuery(function () {
		//$(window).load(function() {
		placeholder.main();
		$(window).resize(function () {
			placeholder.main();
		});
	});
	//Evento para  botones que lanzan un  fomrulario que esta dentro de modal
	jQuery('.js-submit-modal').each(function (index, el) {
		_this = jQuery(this);
		_this.click(function (event) {
			temp = jQuery(this).closest('div.modal').find('form').valid();
			if (temp) {
				////console.log("INICIANDO BOTON ");
				jQuery(this).ladda().ladda('start');
				jQuery(this).closest('div.modal').find('form').submit();
			}
		});
	});
	jQuery('.js-submit-modal-close').each(function (index, el) {
		_this = jQuery(this);
		_this.click(function (event) {
			temp = jQuery(this).closest('div.modal').find('form').valid();
			var modalv = jQuery(this).closest('div.modal');
			if (temp) {
				objGenPlugin.fcPreloadFull();
				modalv.modal('toggle')
				jQuery(this).closest('div.modal').find('form').submit();
			}
		});
	});
	//**********************
	jQuery('body').on('js_event_form_sucess', function (event, data) {
		event.preventDefault();
		// ////console.log("contexto::");
		// ////console.log(data.custom_context);
		// evento para parar los botones  dentro del modal  que contiene el formulario.
		jQuery(data.custom_context.currentForm).closest('div.modal').find('.ladda-button').ladda().ladda('stop');
	});
});
/* alertas */
function _custom_loading() {
	$('body').oLoader({
		wholeWindow: true, //makes the loader fit the window size
		lockOverflow: true, //disable scrollbar on body
		backgroundColor: '#000',
		fadeInTime: 1000,
		fadeLevel: 0.4,
		image: 'images/ownageLoader/loader4.gif',
		hideAfter: 1500
	});
}

function _helper_loading_show() {
	objGenPlugin.fcPreloadFull();
}

function _helper_loading_close() {
	_helper_loading_hide();
}

function _helper_loading_hide() {
	objGenPlugin.fcPreloadFullHide();
}

function _custom_alert(tipo, content) {
	/************************************/
	if (tipo == 'error') {
		color = 'orange';
		icono = 'exclamation-triangle  ';
		title = 'Notice';
	} else if (tipo == 'ok') {
		color = 'green';
		icono = 'check';
		title = 'Alert';
	}
	/***********************************/
	$.alert({
		type: color,
		icon: 'fa fa-' + icono,
		title: title,
		content: content
	});
}

function _custom_alert2(obj) {
	options = {};
	if (_helper_isJSON(obj)) {
		title = obj.title;
		content = obj.content;
		tipo = obj.tipo;
		if (tipo == 'error') {
			color = 'orange';
			icono = 'exclamation-triangle  ';
			if (title == '') {
				title = 'Notice';
			}

		} else {
			color = 'green';
			icono = 'check';
			if (title == '') {
				title = 'Alert';
			}
		}
		options = {
			title: title,
			icon: 'fa fa-' + icono,
			type: color,
			content: content,
		};
		options = $.extend(options, obj);
	} else {
		title = 'Alert';
		color = 'green';
		icono = 'check';
	}
	open_alerts.push($.alert(options));
}

function _helper_close_alerts() {
	$.each(open_alerts, function (i, a) {
		a.close();
		// you can pop the closed ones from refobj array here.
	})
}

function _helper_confirm(content, functions) {
	_custom_confirm(content, functions);
}

function _custom_confirm(content, functions) {
	if (_helper_isJSON(content)) {
		title = content.title;
		content = content.content;
	} else {
		title = 'Confirm!';
	}
	$.confirm({
		title: title,
		backgroundDismissAnimation: '',
		draggable: false,
		icon: ' fa fa-exclamation-triangle ',
		type: 'orange',
		content: content,
		buttons: {
			confirm: functions.confirm,
			cancel: functions.cancel,
		}
	});
}

function _helper_isJSON(something) {
	if (typeof something != 'string') something = JSON.stringify(something);
	try {
		JSON.parse(something);
		return true;
	} catch (e) {
		return false;
	}
}
/**
 * [_helper_open_modal   meidante el ID se abre un modal que esta previamente en la pagina]
 * @param  {[type]} modal  [description]
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
function _helper_open_modal(modal, params) {
	if (jQuery(modal).length <= 0) {
		alert('create modal [' + modal + ']  with: {_helper_modal_template() PHP }');
	}
	jQuery(modal).removeClass('no-footer');
	content = params.content;
	if ('title' in params) {
		title = params.title;
		jQuery(modal).find('.modal-title').html(title);
	}
	if ('subtitle' in params) {
		subtitle = params.subtitle;
		jQuery(modal).find('.modal-subtitle').html(subtitle);
	}
	if ('classes' in params) {
		classes = params.classes;
		jQuery(modal).addClass(classes);
	}
	if ('footer' in params) {
		if (params.footer == false) {
			jQuery(modal).find('.modal-footer').hide();
		}
	}
	jQuery(modal).find('.modal-body').html(content);
	jQuery(modal).modal();
}
/**
 * [_helper_close_modal description] cerrar el modal
 * @return {[type]} [description]
 */
function _helper_close_modal() {
	jQuery('.modal.inmodal.in').modal("hide");
	jQuery('.modal.fade.in').modal("hide");
}

function _helper_modal_close() {
	_helper_close_modal();
}

function _helper_trigger(evento, array) {
	jQuery('body').trigger(evento, array);
}

function _helper_formatNumber(number) {
	var n = new String(number);
	//var numInt; var numDec;
	var str = n.split(".");
	var numInt = str[0]; // parte entera
	var numDec = str[1]; // parte decimal
	if (numDec == undefined) {
		numDec = "00";
	}
	var neg = numInt.indexOf("-");
	var charneg = "";
	if (neg != -1) {
		numInt = numInt.substring(1);
		charneg = "-";
	}
	var totDig = (numInt.length * 1);
	if (totDig > 3) {
		var pos = totDig;
		var i;
		var strNum = "";
		for (i = 0; i < totDig; i++) {
			strNum += numInt.charAt(i);
			if (pos == 7 || pos == 4) {
				strNum += ",";
			}
			pos--;
		}
		n = strNum + "." + numDec;
	} else {
		n = numInt + "." + numDec;
	}
	return charneg + n;
}

jQuery(function () {
	_init_form();
});
